import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1d887172&scoped=true"
import script from "./component.js?vue&type=script&lang=js&external"
export * from "./component.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=1d887172&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=1d887172&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d887172",
  null
  
)

export default component.exports